import { getRequiredValidator } from './required';
const emailTester = // eslint-disable-next-line no-useless-escape
/^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])*[a-zA-Z]+$/;
function validateEmail(email) {
    if (!email) return false;
    const emailParts = email.split('@');
    if (emailParts.length !== 2) return false;
    const account = emailParts[0];
    const address = emailParts[1];
    if (account.length > 64) return false;
    else if (address.length > 255) return false;
    const domainParts = address.split('.');
    if (domainParts.some(function(part) {
        return part.length > 63;
    })) return false;
    return emailTester.test(email);
}
/** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ export const getEmailValidator = function getEmailValidator() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'Please enter a valid email address', required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (value)=>{
        const requiredError = getRequiredValidator(required)(value);
        if (requiredError !== true) {
            return requiredError;
        }
        if (value && typeof value === 'string' && !validateEmail(value)) {
            return errorMsg;
        }
        return true;
    };
};
/** For react-hook-form library. */ export const emailValidation = function emailValidation() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'Please enter a valid email address', opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        validate: {
            email: getEmailValidator(errorMsg, opts.required)
        },
        dataAttr: {
            'data-validation': 'email'
        }
    };
};
